import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
   {
    path: '/news/articles',
    name: 'NewsArticles',
    component: () => import('../views/NewsArticlesView.vue')
  }, 
  {
    path: '/news/events',
    name: 'NewsEvents',
    component: () => import('../views/NewsEventsView.vue')
  },
  {
    path: '/news/event/:nid(\\d+)',
    name: 'NewsEventDetail',
    component: () => import('../views/NewsEventDetailView.vue')
  },
  {
    path: '/cee',
    name: 'Cee',
    component: () => import('../views/CeeView.vue')
  },
  {
    path: '/ceeAdmission/:province/:year',
    name: 'CeeAdmission',
    component: () => import('../views/CeeAdmissionView.vue')
  },    
  {
    path: '/ceeEnrollment/:province/:year',
    name: 'CeeEnrollment',
    component: () => import('../views/CeeEnrollmentView.vue')
  },  
  {
    path: '/ceeAspiration',
    name: 'CeeAspiration',
    component: () => import('../views/CeeAspirationView.vue')
  },
  {
    path: '/ceePreference/:data',
    name: 'CeePreference',
    component: () => import('../views/CeePreferenceView.vue')
  },  
  {
    path: '/college',
    name: 'CollegeList',
    component: () => import('../views/CollegeListView.vue')
  },  
  {
    path: '/college/:code/:name',
    name: 'CollegeDetail',
    component: () => import('../views/CollegeDetailView.vue')
  },
  {
    path: '/major',
    name: 'MajorList',
    component: () => import('../views/MajorListView.vue')
  },  
  {
    path: '/major/:code/:name',
    name: 'MajorDetail',
    component: () => import('../views/MajorDetailView.vue')
  },  
  {
    path: '/position',
    name: 'Position',
    component: () => import('../views/PositionView.vue')
  },
  {
    path: '/planning',
    name: 'Planning',
    component: () => import('../views/PlanningView.vue')
  },
  {
    path: '/planningMore',
    name: 'PlanningMore',
    component: () => import('../views/PlanningMoreView.vue')
  },
  {
    path: '/consultant',
    name: 'Consultant',
    component: () => import('../views/ConsultantView.vue')
  },
  {
    path: '/evaluation/:pattern/:standard',
    name: 'Evaluation',
    component: () => import('../views/EvaluationView.vue')
  },
  // {
  //   path: '/evaluationring',
  //   name: 'EvaluationRing',
  //   component: () => import('../views/EvaluationRingView.vue')
  // },
  // {
  //   path: '/evaluationDimension',
  //   name: 'EvaluationDimension',
  //   component: () => import('../views/EvaluationDimensionView.vue')
  // },
  {
    path: '/report/:rid/:pattern/:standard',
    name: 'Report',
    component: () => import('../views/ReportView.vue')
  },
  {
    path: '/reporttxt/:rid/:pattern/:standard',
    name: 'ReportText',
    component: () => import('../views/ReportTxtView.vue')
  },  
  {
    // path: '/donation/:filename',
    path: '/donation/:evalId/:name/:gender/:subject',
    name: 'Donation',
    component: () => import('../views/DonationView.vue')
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import('../views/AboutView.vue')
  // },
  // {
  //   path: '/app_download',
  //   name: 'Download',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "download" */ '../views/AppDownloadView.vue')
  // },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
